module.exports = __webpack_public_path__ + "img/black_truck.7cba5766.svg";